module.exports = "0.28.0";



//////////////////
// WEBPACK FOOTER
// ./~/autocomplete.js/version.js
// module id = 22
// module chunks = 0 1